import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CoreSettingsService } from '../../settings/core-settings.service'

export type NewsletterType = {
  email: string
  name: string
  type: ISourceTypes
  userId: number
}

export enum ISourceTypes {
  prodPageRu = 0,
  prodPageEn = 1,
  beatmakersTV = 2,
  beatmakerTV = 3,
  widget = 4
}

export interface INewsletterServiceResponse {
  response: {
    resultCode: number
    message: string
  }
}

@Injectable({
  providedIn: 'root'
})
export class NewsLetterService {
  constructor(
    private http: HttpClient,
    private coreSettings: CoreSettingsService
  ) {}

  subscribeToNewsletter(data: NewsletterType) {
    const baseUrl = this.coreSettings.settings.urls.prodspageServiceAPI
    const resultUrl = `${baseUrl}/subscribers`

    return this.http.post<INewsletterServiceResponse>(resultUrl, data)
  }
}
